import { bucketNumber } from './bucketNumber';
import { numberAbbreviation } from './numberAbbreviation';

export const getRankTier = (rank: number): string => {
  const max = 85900000;
  const percent = rank / max;
  let bucket = 0.0;
  while (bucket < 100) {
    bucket += 0.05;
    if (percent < bucket) {
      const position = bucket < 0.5 ? 'Top' : 'Bottom';
      const percentBucket = `${position} ${(bucket * 100).toFixed(0)}%`;
      const numberBucket = bucketNumber(
        rank,
        [500, 1000, 10000, 25000, 50000, 100000, 250000, 500000, 1000000, 0]
      );
      if (bucket < 0.5) {
        return (
          `${percentBucket}` +
          (numberBucket ? ` / Top ${numberAbbreviation(numberBucket, 0)}` : '')
        );
      }
      return `${percentBucket}`;
    }
  }
  return `Unranked`;
};
